import { render } from "./StandingsTable.vue?vue&type=template&id=72cee63a&scoped=true"
import script from "./StandingsTable.vue?vue&type=script&lang=js"
export * from "./StandingsTable.vue?vue&type=script&lang=js"

import "./StandingsTable.vue?vue&type=style&index=0&id=72cee63a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cee63a"]])

export default __exports__